import config from 'config';
import { APIResponse } from 'types/Cokiba';

export interface Content {
  key: string;
  content: string;
}

type GetResponse = APIResponse<Content>;
type UpdateResponse = APIResponse<Content>;

export async function getContent(key: string): Promise<Content | null> {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      return null;
    }

    const url = new URL(`${ config.baseUrl }/contents/${key}`);
    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    if (response.status !== 200) {
      return null;
    }

    const content = await response.json() as GetResponse;
    const { payload } = content;

    return payload || null;
  } catch (err) {
    throw new Error(
      'Ocurrió un problema inesperado al momento de intentar ' +
      'recuperar el contenido. ',
    );
  }
}

export async function updateContentFiles(
  key: string,
  files: Record<string, File>,
): Promise<Content | false> {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      return false;
    }

    const formData = new FormData();
    for (const [field, file] of Object.entries(files)) {
      formData.append(field, file);
    }

    const url = new URL(`${ config.baseUrl }/contents/${key}`);
    const response = await fetch(url.toString(), {
      method: 'PUT',
      headers: {
        Authorization: token,
      },
      body: formData,
    });

    if (response.status !== 200) {
      return false;
    }

    const content = await response.json() as UpdateResponse;
    const { payload } = content;

    return payload || false;
  } catch (err) {
    throw new Error(
      'Ocurrió un problema inesperado al momento de intentar ' +
      'actualizar el contenido. ',
    );
  }
}

export async function updateContent(
  key: string,
  contentValue: string,
): Promise<Content | false> {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      return false;
    }

    const url = new URL(
      `${ config.baseUrl }/contents/${key}`,
    );
    const response = await fetch(url.toString(), {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify({ content: contentValue }),
    });

    if (response.status !== 200) {
      return false;
    }

    const content = await response.json() as UpdateResponse;
    const { payload } = content;

    return payload || false;
  } catch (err) {
    throw new Error(
      'Ocurrió un problema inesperado al momento de intentar ' +
      'actualizar el contenido. ',
    );
  }
}
